import { cva } from 'class-variance-authority';

export const buttonVariants = cva(
  "relative inline-flex items-center justify-center whitespace-nowrap rounded-md text-sm leading-[18px] transition-all disabled:pointer-events-none [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-6 shrink-0 [&_svg]:shrink-0 outline-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-red-500/20 dark:aria-invalid:ring-red-500/40 aria-invalid:border-red-500 [&>svg]:[stroke-width:1.25]",
  {
    variants: {
      variant: {
        primary:
          'bg-teal-600 text-white hover:bg-teal-500 hover:inset-shadow-[0_0_0_2px_var(--color-teal-400)] disabled:bg-teal-100',
        secondary: 'bg-denim-500 text-white hover:bg-denim-400 disabled:bg-denim-100',
        terciary:
          'text-denim-500 border-gray-300 hover:bg-teal-100 hover:border-teal-200 disabled:border-gray-100 disabled:text-gray-300',
        destructive:
          'bg-red-600 text-white hover:bg-red-500 hover:inset-shadow-[0_0_0_2px_var(--color-red-400)] disabled:bg-red-100',
        destructive_terciary:
          'text-red-400 border-red-200 hover:text-red-500 hover:bg-red-100 hover:border-red-200 disabled:text-red-200 disabled:border-red-100',
        primary_terciary:
          'text-teal-600 border-teal-200 hover:text-teal-700 hover:bg-teal-100 hover:border-teal-200 disabled:text-teal-200 disabled:border-teal-100',
        link: 'text-teal-600 hover:text-teal-500',
        ghost: 'p-0 h-fit hover:bg-gray-200',
      },
      size: {
        md: 'h-8 px-5 py-1 rounded-2xl font-medium',
        lg: 'h-10 px-8 py-1 rounded-[20px] font-semibold',
        xl: 'h-12 px-8 py-2 rounded-full font-semibold',
      },
      icon: {
        back: 'has-[>svg]:pr-4 has-[>svg]:pl-1 gap-4 justify-start',
        trailing: 'has-[>svg]:pl-5 has-[>svg]:pr-1 gap-4 justify-between',
        leading: 'has-[>svg]:pr-5 has-[>svg]:pl-4 gap-2',
        only: 'p-0 rounded-full',
      },
      isLoading: {
        true: 'justify-center pointer-events-none',
      },
    },
    defaultVariants: {
      variant: 'primary',
      size: 'md',
    },
    compoundVariants: [
      {
        variant: ['primary', 'destructive'],
        class: 'shadow-box-lg disabled:shadow-none',
      },
      {
        variant: 'destructive',
        class: 'font-semibold',
      },
      {
        variant: ['terciary', 'destructive_terciary', 'primary_terciary'],
        class: 'bg-white border shadow-box-xs font-medium',
      },
      {
        variant: ['terciary', 'destructive_terciary', 'primary_terciary'],
        size: 'md',
        class: 'text-xs leading-4',
      },
      {
        variant: ['secondary', 'terciary', 'destructive_terciary'],
        size: 'lg',
        class: 'px-6',
      },
      {
        variant: 'terciary',
        size: 'md',
        class: 'text-denim-800',
      },
      {
        variant: 'secondary',
        icon: 'only',
        class: 'disabled:bg-plum-100',
      },
      {
        icon: 'back',
        size: 'lg',
        class: 'has-[>svg]:pr-5 has-[>svg]:pl-2 gap-5',
      },
      {
        icon: 'trailing',
        size: 'lg',
        class: 'has-[>svg]:pr-2 has-[>svg]:pl-5 gap-5',
      },
      {
        icon: 'leading',
        size: 'lg',
        class: 'has-[>svg]:pr-6 has-[>svg]:pl-5 gap-3',
      },
      {
        variant: 'terciary',
        icon: 'trailing',
        size: 'md',
        class: 'has-[>svg]:pl-4',
      },
      {
        variant: 'destructive_terciary',
        icon: 'leading',
        size: 'md',
        class: 'has-[>svg]:pl-3 has-[>svg]:pr-4',
      },
      {
        icon: 'back',
        size: 'xl',
        class: 'has-[>svg]:pr-6 has-[>svg]:pl-2.5 gap-6',
      },
      {
        icon: 'trailing',
        size: 'xl',
        class: 'has-[>svg]:pr-2.5 has-[>svg]:pl-6 gap-6',
      },
      {
        icon: 'leading',
        size: 'xl',
        class: 'has-[>svg]:pr-5 has-[>svg]:pl-4 gap-3',
      },
      {
        icon: 'only',
        size: 'md',
        class: 'size-8 min-w-8 min-h-8 p-1',
      },
      {
        icon: 'only',
        size: 'lg',
        class: 'size-10 min-w-10 min-h-10 p-2',
      },
      {
        icon: 'only',
        size: 'xl',
        class: 'size-12 min-w-12 min-h-12 p-3',
      },
      {
        variant: 'link',
        class: 'font-medium has-[>svg]:pr-0 has-[>svg]:pl-0 gap-2',
        icon: 'leading',
      },
      {
        variant: 'link',
        class: 'py-0 h-fit',
        size: ['md', 'lg', 'xl'],
      },
    ],
  }
);
